module.exports = __webpack_public_path__ + "media/assets/icons/contact-9fc8b90e81fe7fc649cb0b62cc5e23ef.svg";